import React from "react";
import { IconButton } from "@evergis/ui";
import { useSelector } from "react-redux";

import PlayButton from "./PlayButton";
import { AxisControllerContainer, GradientLeft, Space } from "../styled";
import { getSettingsProp } from "../../../ducks/appConfig";
import { useNextStepHandler, usePrevStepHandler } from "../hooks";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";

export default () => {
  const dataFilterPlayButton = useSelector(getSettingsProp("dataFilterPlayButton"));
  const nextHandler = useNextStepHandler();
  const prevHandler = usePrevStepHandler();
  const { isPresentationMode } = usePresentationMode();

  return (
    <>
      <AxisControllerContainer>
        <IconButton style={{ paddingLeft: "1rem" }} kind="prev" onClick={prevHandler} />
        {dataFilterPlayButton && !isPresentationMode ? <PlayButton /> : <Space />}
        <IconButton style={{ paddingRight: "1rem" }} kind="next" onClick={nextHandler} />
        <GradientLeft />
      </AxisControllerContainer>
    </>
  );
};
